
import { Component } from 'react'
import Post from '../../src/components/post'
import ComponentTree from '../../src/components/component-tree'
import components from '../../src/components/md-components'

export default (props) => {
  const data = {
  "layout": "post",
  "title": "Delta Rae at Steel Stacks",
  "date": "2014-06-23 08",
  "comments": "true",
  "categories": "[\"photo\", \"concert photography\"]",
  "path": "pages/posts/undefined.js",
  "permalink": "posts/undefined",
  "created": "2014-06-23",
  "tags": [
    "photo",
    "concert photography"
  ],
  "draft": false
}
  const body = {"type":"p","props":{},"children":[{"type":"img","props":{"src":"/static/images/posts/2014-06-23-delta/DSCF4785.jpg","alt":"1"}},"\n",{"type":"img","props":{"src":"/static/images/posts/2014-06-23-delta/DSCF4772.jpg","alt":"2"}},"\n",{"type":"img","props":{"src":"/static/images/posts/2014-06-23-delta/DSCF4779.jpg","alt":"3"}},"\n",{"type":"img","props":{"src":"/static/images/posts/2014-06-23-delta/DSCF4791.jpg","alt":"4"}}]}
  return (
    <Post {...data}>
      <ComponentTree {...body} components={components} />
    </Post>
  )
}
